import { useInteractionContext } from '../interaction-context';
import { addError, addErrorToAll, getActiveInteraction } from '../interaction-metrics';

/**
 * Usage:
 * ```
 * import { useUFOReportError } from '@atlaskit/react-ufo/use-error-handler';
 *
 * const reportError = useUFOReportError();
 *
 * try {
 *   // something that can throw an error
 * } catch (error) {
 *   reportError(error)
 * }
 * ```
 * @returns `reportError` function
 */
export function useUFOReportError() {
  var ufoContext = useInteractionContext();
  var reportError = function reportError(error) {
    var interaction = getActiveInteraction();
    if (interaction !== null && interaction !== void 0 && interaction.id) {
      addError(interaction.id, error.name, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, error.name, error.errorMessage, error.errorStack, error.forcedError);
    } else {
      addErrorToAll(error.name, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, error.name, error.errorMessage, error.errorStack);
    }
  };
  return reportError;
}